import { TextField } from "@mui/material";
import React from "react";
import { ClientContext } from "../../../store/context";
import { isEmail } from "../../utils/generalUtils";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

function ReservationForm() {
  const { formBody, setFormBody } = React.useContext(ClientContext);

  return (
    <div className="reservation-form-container">
      <TextField
        id="outlined-basic"
        label="Name"
        variant="outlined"
        required
        value={formBody?.customerName}
        onChange={(e) =>
          setFormBody({ ...formBody, customerName: e.target.value })
        }
      />
      <TextField
        id="outlined-basic"
        label="Surname"
        variant="outlined"
        required
        value={formBody?.customerLastName}
        onChange={(e) =>
          setFormBody({ ...formBody, customerLastName: e.target.value })
        }
      />
      <PhoneInput
        label="Phone number"
        onChange={(value, country, e, formattedValue) => {
          setFormBody({ ...formBody, customerPhone: formattedValue });
        }}
        value={formBody?.customerPhone}
        inputProps={{
          name: "Phone number",
          required: true,
          autoFocus: true,
        }}
        required
        country="gr"
        inputStyle={{ width: "100%" }}
      />
      <TextField
        id="outlined-basic"
        label="E-mail"
        variant="outlined"
        error={!isEmail(formBody.customerMail) && formBody.customerMail}
        helperText={
          !isEmail(formBody.customerMail) && formBody.customerMail
            ? "Invalid Email Format"
            : ""
        }
        required
        value={formBody?.customerMail}
        onChange={(e) =>
          setFormBody({ ...formBody, customerMail: e.target.value })
        }
      />
      <TextField
        id="outlined-basic"
        label="Address"
        variant="outlined"
        required
        value={formBody?.customerAddress}
        onChange={(e) =>
          setFormBody({ ...formBody, customerAddress: e.target.value })
        }
      />
      <TextField
        id="outlined-basic"
        label="Country"
        variant="outlined"
        required
        value={formBody?.customerCountry}
        onChange={(e) =>
          setFormBody({ ...formBody, customerCountry: e.target.value })
        }
      />
      <TextField
        id="outlined-basic"
        label="Flight Number"
        variant="outlined"
        value={formBody?.flightNumber}
        onChange={(e) =>
          setFormBody({ ...formBody, flightNumber: e.target.value })
        }
      />
    </div>
  );
}

export default ReservationForm;
